import { api } from './api.js';

export interface DemandMissSummary {
  total: number;
  by_location: Array<{ location_id: string; name: string | null; count: number }>;
  by_date: Array<{ date: string; count: number }>;
}

export interface DemandMiss {
  _id: string;
  reason: 'no_match' | 'slot_taken' | 'car_blocked';
  source: 'search' | 'create' | 'payment' | 'reschedule' | 'car_change';
  location_id: string;
  pickup_at: string;
  return_at: string;
  car_id?: string;
  category_id?: string;
  was_authenticated: boolean;
  created_at: string;
}

export interface DemandMissListResponse {
  items: DemandMiss[];
  total: number;
  page: number;
  pages: number;
}

export interface DemandMissParams {
  from?: string;
  to?: string;
  location_id?: string;
  reason?: string;
  page?: number;
  limit?: number;
}

function toQuery(params: DemandMissParams): string {
  const qs = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== '') qs.set(k, String(v));
  }
  const s = qs.toString();
  return s ? `?${s}` : '';
}

/** 214 (#310): the turned-away-demand report. */
export const demandApi = {
  summary: (params: DemandMissParams = {}) =>
    api.get<DemandMissSummary>(`/demand-misses/summary${toQuery(params)}`),
  list: (params: DemandMissParams = {}) =>
    api.get<DemandMissListResponse>(`/demand-misses${toQuery(params)}`),
};
